<template>
  <div class="keyPieces">
        <a-drawer
        :width="1000"
        placement="right"
        :closable="true"
        @close="closeDetail"
        :wrapStyle="{'padding':'0'}"
        :visible="true">
         <template slot="title">
            <span class="user-title">关键件清单</span>
        </template>
         <div class="header">
            <a-row style="width:100%;">
                <a-col :sm="24" :md="20" :lg="20" :xl="20">
                <a-row>
                    <a-col :sm="24" :md="12" :lg="12" :xl="12">
                    <span class="headerContent">证书编号：{{dataObj.number}}</span>
                    </a-col>
                    <a-col :sm="24" :md="24" :lg="24" :xl="12">
                    产品名称：
                    <a-popover placement="top">
                        <template slot="content">
                            <p style="max-width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{dataObj.product}}</p>
                        </template>
                        <span class="headerContent">{{dataObj.product}}</span>
                    </a-popover>
                    </a-col>
                    <a-col :sm="24" :md="24" :lg="24" :xl="12">
                    生产企业：
                    <a-popover placement="top">
                        <template slot="content">
                            <p v-if="dataObj.factoryName" style="max-width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{dataObj.factoryName}}</p>
                        </template>
                        <span class="headerContent">{{dataObj.factoryName}}</span>
                    </a-popover>
                    </a-col>
                    <a-col :sm="24" :md="24" :lg="24" :xl="12">
                    系列型号：
                    <a-popover placement="top">
                        <template slot="content">
                            <p v-if="dataObj.modelSpecification" style="max-width: 500px;word-wrap: break-word;word-break: break-all;overflow: hidden;">{{dataObj.modelSpecification}}</p>
                        </template>
                        <span class="headerContent">{{dataObj.modelSpecification}}</span>
                    </a-popover>
                    </a-col>
                </a-row>
                </a-col>
            </a-row>
            <div class="search-area">
                 <a-input v-model="searchVal" allowClear @pressEnter="searchChange" placeholder="证书编号、元器件名称、制造商、在用型号、规格参数" style="width: 400px; border-radius: 0;height: 35px;outline: none;"/>
                 <a-button class="search-btn" type="primary" icon="search" @click="searchChange" />
                <a-button v-if="roles.includes('CERTIFICATE_EXPORT')" class="btn" style="margin-top: 5px;margin-left: 20px" type="primary" @click="outputAction(dataObj.id)">导出</a-button>
            </div>
            </div>
             <div class="table">
                <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="false"
                :rowKey="r => r.index"
                :loading="loading"
                @change="pagChange"
                @expandRowByClick="true"
                :scroll="{ x: 1700, y: 500 }">
                <template slot="manufacturerName" slot-scope="manufacturerName">
                    
                    <a-popover placement="top">
                        <template slot="content">
                            <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="manufacturerName">{{manufacturerName}}</p>
                        </template>
                            <span class="item-type" v-if="manufacturerName">{{manufacturerName}}</span>
                        </a-popover>
                    </template>
                <template slot="product" slot-scope="product">
                    <a-popover placement="top">
                        <template slot="content">
                            <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="product">{{product}}</p>
                        </template>
                            <p class="item-type" v-if="product">{{product}}</p>
                        </a-popover>
                </template>
                <template slot="type"  slot-scope="type">
                        <p>{{type | selectType}}</p>
                    </template>
                    <template slot="modelInUse" slot-scope="record">
                    <a-popover placement="topRight">
                        <template slot="content">
                                <p style="width: 200px;" v-if="record.modelInUse">{{record.modelInUse}}</p>
                        </template>
                            <p class="item-type" v-if="record.modelInUse">{{record.modelInUse}}</p>
                        </a-popover>
                </template>
                <template slot="modelSpecification" slot-scope="modelSpecification">
                    <a-popover placement="topRight">
                        <template slot="content">
                                <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="modelSpecification"><span>{{modelSpecification}}</span></p>
                        </template>
                            <p class="item-type" v-if="modelSpecification"><span>{{modelSpecification}}；</span></p>
                        </a-popover>
                </template>
                <template slot="mySpecification" slot-scope="mySpecification">
                    <a-popover placement="topRight">
                        <template slot="content">
                                <p style="width: 200px;word-wrap: break-word;word-break: break-all;overflow: hidden;" v-if="mySpecification">{{mySpecification}}</p>
                        </template>
                        <p class="item-type" v-if="mySpecification">{{mySpecification}}</p>
                    </a-popover>
                </template>
                    <template slot="operation"  slot-scope="record">
                    <a-button type="link" @click="showDrawer(record)" style="padding:0;">详情</a-button>
                    <!-- <a-button type="link" v-if="roles.includes('KEYPIECECERTIFICATE_EDIT')" @click="delAction(record)">删除</a-button> -->
                    </template>

                    <!-- 状态 -->
                    <template slot="state" slot-scope="state">
                    <common-badge :state="state" :text="state"></common-badge>
                    </template>
                </a-table>
            </div>
            <template>
                <a-drawer
                :width="600"
                placement="right"
                :closable="false"
                @close="closeDrawer"
                :wrapStyle="{'padding':'0'}"
                :visible="drawervisible">
                <template slot="title">
                    <span class="user-title">证书详情</span>
                </template>
                <div class="detail-content" style="font-size:12px;">
                    <div class="detail-message">
                    <p>
                        <span class="detail-message-key">证书编号：</span>
                        <span class="detail-message-value" v-if="detailObj.number">{{detailObj.number}}</span>
                    </p>
                        <p>
                        <span class="detail-message-key" v-if="detailObj.keyPieceType == '0'">产品名称：</span>
                        <span class="detail-message-key" v-if="detailObj.keyPieceType == '1'">元件名称：</span>
                        <span class="detail-message-value" v-if="detailObj.product">{{detailObj.product}}</span>
                        </p>
                    <p v-if="detailObj.keyPieceType == '0'">
                        <span class="detail-message-key">委托人名称：</span>
                        <span class="detail-message-value" v-if="detailObj.entrustName"> {{detailObj.entrustName}}</span>
                        </p>
                        <p>
                        <span class="detail-message-key">生产者（制造商）名称：</span>
                        <span class="detail-message-value" v-if="detailObj.manufacturerName">{{detailObj.manufacturerName}}</span>
                        </p>
                        <p>
                        <span class="detail-message-key">生产企业（生产厂家）名称：</span>
                        <span class="detail-message-value" v-if="detailObj.factoryName">{{detailObj.factoryName}}</span>
                        </p>
                        <p v-if="detailObj.keyPieceType == '0'">
                        <span class="detail-message-key">型号/规格：</span>
                        <span class="detail-message-value" v-if="detailObj.modelSpecification">{{detailObj.modelSpecification}}&nbsp;&nbsp;<i class="use-btn" v-if="detailObj.modelInUses" @click="openUseBox">在用型号（{{detailObj.modelInUses.length}}）</i><i class="use-btn" v-else>在用型号（0）</i></span>
                        </p>
                        <div v-if="showUse && detailObj.modelInUses" class="showUse">
                        <div v-for="(item, index) in detailObj.modelInUses" :key="index">
                            <p v-if="item.name">{{item.name}} {{item.mySpecification}}</p>
                        </div>
                        </div>
                        <div v-if="modelAnnexes.length > 0">
                        <div class="detail-message-value flex-text" v-for="(item, index) in modelAnnexes" :key="index">
                            <template v-if="item.type == '0'"> 
                                <!-- 图片格式 -->
                                <a-popover placement="left">
                                    <template slot="content">
                                        <a class="max-text" style="color:#a2a2a2;font-weight: 600">{{item.fileName}}</a>
                                    </template>
                                        <a class="max-text" style="color:#a2a2a2">{{item.fileName}}</a>
                                </a-popover>
                                <a v-if="roles.includes('REPORT_PREVIEW') || roles.includes('CERTIFICATE_EDIT')" @click="preview(item.inlineUrl)">预览</a>
                                <a v-if="roles.includes('REPORT_DOWNLOAD') || roles.includes('CERTIFICATE_EDIT') " :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                            </template>
                            <template v-if="item.type == '1'"> 
                                <!-- pdf格式 -->
                                <a-popover placement="left">
                                    <template slot="content">
                                        <a class="max-text" style="color:#a2a2a2;font-weight: 600">{{item.fileName}}</a>
                                    </template>
                                        <a class="max-text" style="color:#a2a2a2">{{item.fileName}}</a>
                                </a-popover>
                                <a v-if="roles.includes('REPORT_PREVIEW') || roles.includes('CERTIFICATE_EDIT') " target="_blank" :href="wordPreviewUrl(item.inlineUrl)" >预览</a> 
                                <a v-if="roles.includes('REPORT_DOWNLOAD') || roles.includes('CERTIFICATE_EDIT') " :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                            </template>
                            <template v-if="item.type == '2'">
                                <a-popover placement="left">
                                    <template slot="content">
                                        <a class="max-text" style="color:#a2a2a2;font-weight: 600">{{item.fileName}}</a>
                                    </template>
                                        <a class="max-text" style="color:#a2a2a2">{{item.fileName}}</a>
                                </a-popover>
                                <a v-if="roles.includes('REPORT_PREVIEW') || roles.includes('CERTIFICATE_EDIT') " @click="previewOther(item.inlineUrl)">预览</a>
                                <a v-if="roles.includes('REPORT_DOWNLOAD') || roles.includes('CERTIFICATE_EDIT') " :href="wordPreviewUrl(item.attachmentUrl)" :download="item.fileName">下载</a>
                            </template>
                        </div>
                        </div>
                        <p v-if="detailObj.keyPieceType == '1'">
                        <span class="detail-message-key">在用型号/规格：</span>
                        <span class="detail-message-value" v-if="detailObj.modelSpecification">{{detailObj.modelSpecification}}</span>
                        </p>
                        <p>
                        <span class="detail-message-key">产品标准和技术要求：</span>
                        <span class="detail-message-value" v-if="detailObj.standard">{{detailObj.standard}}</span>
                        </p>
                        <p v-if="detailObj.keyPieceType == '0'">
                        <span class="detail-message-key">发证日期：</span>
                        <span class="detail-message-value" v-if="detailObj.issueDate">{{detailObj.issueDate | formatDate}}</span>
                        </p>
                        <p v-if="detailObj.keyPieceType == '0'">
                        <span class="detail-message-key">有效期：</span>
                        <span class="detail-message-value" v-if="detailObj.expireDate">{{detailObj.expireDate | formatDate}}</span>
                        </p>
                        <p v-if="detailObj.keyPieceType == '0'">
                        <span class="detail-message-key">首次发证：</span>
                        <span class="detail-message-value" v-if="detailObj.originalChangingTime">{{detailObj.originalChangingTime | formatDate}}</span>
                        </p>
                        <p v-if="detailObj.keyPieceType == '1'">
                        <span class="detail-message-key">是否送检：</span>
                        <span class="detail-message-value" v-if="detailObj.type">{{detailObj.type | selectType}}</span>
                        </p>
                    </div>
                </div>
                </a-drawer>
            </template>
        </a-drawer>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
import { getKeyPieceCertificates} from '@/utils/auth'
import {formatDate,dateDiff} from '@/utils/date';
import {getkeyData, outputList, getkeyUseDataInfo, getDataInfoUnlicense, removeKeyPart, removeUnlicenseKeyPart} from '@/api/keyPart';

export default {
    props: {
        id: Number
    },
  data() {
    const align = 'center'
    return {
      data:'',
      loading:false,
      columns: [
        {
          title: "NO",
          dataIndex: "index",
          align,
          width: 80
        },
        {
          title: "证书编号",
          dataIndex: "number",
          align,
          width: 200
        },
        {
          title: "证书状态",
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' },
          align,
          width: 120,
          sorter: true
        },
        {
          title: "元器件名称",
          dataIndex: "product",
          scopedSlots: { customRender: 'product' },
          align,
          width:200,
          sorter: true
        },
        {
          title: "制造商",
          dataIndex: 'manufacturerName',
          scopedSlots: { customRender: 'manufacturerName' },
          align,
          width:200,
          sorter: true
        },
        {
          title: "在用型号",
          scopedSlots: { customRender: 'modelInUse' },
          align,
          width:200
        },
        {
          title: "规格参数",
          dataIndex: 'mySpecification',
          scopedSlots: { customRender: 'mySpecification'},
          align,
          width:200,
        },
        {
          title: "是否送检",
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          align,
          width: 120,
          sorter: true
        },
        {
          title: "操作",
          scopedSlots: { customRender: 'operation' },
          align,
          width: 120,
          fixed: 'right'
        },
      ],
      tableData: [],
      dataObj:{
        company:'',
        number:'',
        product:'',
      },
      drawervisible:false,
      detailObj:{

      },
      pageNum: '',
      blurry: '',
      showUse: false,
      modelAnnexes: [],
      roles: [],
      keyId: '',
      searchVal: '',
      sortBy: 'product',
      sortType: 'ASC',
      tableDataArr: [],
      exportStatus: true, // 可导出
    }
  },
  created() {
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
    let query = this.$route.query;
    this.keyId = this.id;
    this.getkeyData(this.id);
  },
  mounted() {
      
  },
  methods: {
    preview(url){
        this.previewVisible = true;
        this.previewImage = this.wordPreviewUrl(url);
    },
    // 预览 word 和 PDF 时
    wordPreviewUrl(url) {
      if (url && url[0] === '/') {
        return window.location.origin + url;
      } else {
        return url;
      }
    },
    closeDetail() {
        this.$emit('hideAction');
    },
    pagChange(pagination, filters, sorter){
        if (sorter) {
            this.sortBy = sorter.columnKey;
        if (sorter.order == "ascend") {
            this.sortType = 'DESC'
        } else {
            this.sortType = 'ASC'
        }
      } else {
        this.sortBy = '';
        this.sortType = '';
      }
      this.getkeyData(this.id);
    },
    searchChange() {
      let val = this.searchVal;
      let userArr = this.tableDataArr;
      let newArr = [];
      if (val) {
            userArr.map((i) => {
                if (i.number && i.number.indexOf(val) != -1 || i.product && i.product.indexOf(val) != -1 || i.manufacturerName && i.manufacturerName.indexOf(val) != -1 || i.modelInUse && i.modelInUse.indexOf(val) != -1 || i.mySpecification && i.mySpecification.indexOf(val) != -1) {
                    newArr.push(i);
                }
            })
        } else {
            userArr.map((i) => {
                newArr.push(i)
            })
        }
        this.tableData = newArr;
    },
    delAction(record) {
      let that = this;
      that.$confirm({
            title: '确定要删除吗',
            content: '已报备，从关键件清单里移除该型号的关键元器件',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
              if (record.keyPieceType == '0') {
                that.removeKeyPart(record.id);
              } else {
                that.removeUnlicenseKeyPart(record.id);
              }
            },
        })
    },
    removeKeyPart(id) {
      removeKeyPart(id)
        .then(res => {
          this.$message.success('删除成功');
          this.getkeyData(this.keyId);
          this.$bus.$emit('ifReload');
        })
        .catch(error => {
          console.log(error);
        })
    },
    removeUnlicenseKeyPart(id) {
      removeUnlicenseKeyPart(id)
        .then(res => {
          this.$message.success('删除成功');
          this.getkeyData(this.keyId);
          this.$bus.$emit('ifReload');
        })
        .catch(error => {
          console.log(error);
        })
    },
    openUseBox() {
      this.showUse = !this.showUse;
    },
    outputAction(id) {
      let that = this;
      if (that.exportStatus) {
        that.$confirm({
            title: '确定要导出吗',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
                that.exportStatus = false;
                that.$message.success('拼命导出中，请稍后...');
                outputList(id)
                  .then(res => {
                      const content = res;
                      const blob = new Blob([res], {type: "application/vnd.ms-excel"});
                      const fileName = that.dataObj.company + '/' + that.dataObj.number  + '.xls'
                      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
                      //IE10以上支持blob但是依然不支持download
                      if ('download' in document.createElement('a')) { //支持a标签download的浏览器
                        const link = document.createElement('a')//创建a标签
                        link.download = fileName//a标签添加属性
                        link.style.display = 'none'
                        link.href = URL.createObjectURL(blob)
                        document.body.appendChild(link)
                        link.click()//执行下载
                        URL.revokeObjectURL(link.href) //释放url
                        document.body.removeChild(link)//释放标签
                      } else { //其他浏览器
                        navigator.msSaveBlob(blob, fileName)
                      }
                      setTimeout(() => {
                        that.exportStatus = true;
                      }, 1500)
                  })
                  .catch(error => {
                    that.exportStatus = true;
                    console.log(error);
                  })
            },
        })
      } else {
        that.$message.warning('正在导出中，请勿重复操作！');
      }
    },
    getkeyData(id) {
      getkeyData(id, this.sortBy, this.sortType)
        .then((res) => {
          let newDateObj = res;
          this.dataObj.company = newDateObj.dept.name
          this.dataObj.number = newDateObj.number
          this.dataObj.product = newDateObj.product
          this.dataObj.id = newDateObj.id;
          this.dataObj.factoryName = newDateObj.factoryName;
          this.dataObj.modelSpecification = newDateObj.modelSpecification;

          this.tableData = newDateObj.keyPieces
          this.tableDataArr = newDateObj.keyPieces
          this.tableData.map((i, index) => {
            i.index = index + 1;
          })
        })
        .catch(error => {
          console.log(error);
        })
    },
    
    /**
     * 关闭详情
     */
    closeDrawer(){
      this.drawervisible =false
    },
    /**
     * 打开详情
     */
    showDrawer(args){
      let type = args.keyPieceType;
      this.showUse = false;
      if (type == '0') {
        getkeyUseDataInfo(args.id)
        .then((res) => {
            this.drawervisible= true
            this.detailObj = res;
            this.detailObj.keyPieceType = type;
            this.modelAnnexes = res.modelAnnexes;
        })
        .catch(error => {
          console.log(error);
        })
      } else {
        getDataInfoUnlicense(args.id)
        .then((res) => {
            this.drawervisible= true
            this.detailObj = res;
            this.detailObj.keyPieceType = type;
        })
        .catch(error => {
          console.log(error);
        })
      }
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy/MM/dd");
    },
    dateDiff(time){
      return dateDiff(time);
    },
    selectType(val) {
      if (val == '0') {
        return '主检'
      } else if(val == '1') {
        return '非主检'
      } else {
        return '-'
      }
    },
    spliceChinese(val) {
      if (val) {
        var reg = /[\u4e00-\u9fa5]/g;
        if (val.match(reg)) {
            return val.match(reg).join('');
          } else {
            return val;
          }
      }
    }
  },
}
</script>
<style lang="less" scoped>
@detail-gray-color:#a2a2a2;
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
.search-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
}
.search-btn {
    width: 50px;
    height: 35px;
    margin-right: 10px;
    border-radius: 0;
}
.header {
    margin-bottom: 15px;
}
  .headerContent{
        line-height: 30px;
        display: inline-block;
        width: 300px;
        overflow: hidden;/*超出部分隐藏*/
        white-space: nowrap;/*不换行*/
        text-overflow:ellipsis;
        vertical-align: middle;
        cursor: pointer;
      }
  .max-text {
    display:inline-block; 
    width: 200px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
.detail-message-value{
    color: #a2a2a2;
    overflow: hidden;
    a{
      padding: 0 8px;
      line-height: 28px;
    }
  }
  .flex-text {
    display: flex;
    align-items: center;
  }
.use-btn {
  display: inline-block;
  border-radius: 3px;
  background-color: rgba(238, 248, 232, 1);
  color: rgba(122, 199, 86, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(122, 199, 86, 1);
  padding: 0 3px;
  cursor: pointer;
  margin-left: 5px;
}
  .showUse {
    line-height: 17px;
    background-color: rgba(238, 248, 232, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 12px;
    text-align: justify;
    font-family: Roboto;
    border: 1px solid rgba(220, 224, 231, 0.13);
    padding: 10px;
    overflow: hidden;
  }
  .keyPieces{
    min-height: 100%;
    .header{
      margin-bottom: 24px;
      padding: 16px;
      overflow: hidden;
      background-color: #fff;
      display: flex;
    }
    .table{
      background-color: #fff;
    }
  }
  .detail-content{
    font-size: 14px;
    .detail-message{
      padding-bottom: 20px;
      // border-bottom: 1px solid #ccc;
      p{
        line-height: 28px;
        .detail-message-key{
          color: #333;
        }
      }
    }
    .detail-adjunct{
      border-bottom: 1px solid #ccc;
      h3{
        border-bottom: 1px solid #ccc;
        line-height: 20px;
        padding: 12px 0;
        font-weight: bold;
      }
      .detail-adjunct-content{
        padding: 12px;
        a{
          padding: 0 8px;
          line-height: 28px;
        }
        
      }
    }
    .detail-record{

      h3{
        border-bottom: 1px solid #ccc;
        line-height: 20px;
        padding: 12px 0;
        font-weight: bold;
      }
      .detail-record-content{
        line-height: 28px;
        padding: 14px;
        overflow: hidden;
        border: 1px solid #ccc;
        border-top: 0;
      }
      .detail-record-adjunct{
        overflow: hidden;
      }
      span{
        margin-right: 15px;
      }
      a{
        padding: 0 8px;
        line-height: 28px;
      }
    }
    
  }
</style>